import React, { ReactNode, useState } from 'react';
import DashboardContext, { Accounts } from './dashboardContext';

const DashboardProvider = ({ children }: { children: ReactNode }) => {
  const [isMobileView, setIsMobileView] = useState<boolean | undefined>(
    undefined
  );
  const [balances, setBalances] = useState<[]>([]);
  const [supportedCurrencies, setSupportedCurrencies] = useState<[] | null>(
    null
  );
  const [supportedBalanceCurrencies, setSupportedBalanceCurrencies] =
    useState<[]>();
  const [accountName, setAccountName] = useState<string>('');
  const [user, setUser] = useState<Accounts | null>(null);
  const [businessName, setBusinessName] = useState<string>('');
  const [customer, setCustomer] = useState<Accounts | null>(null);
  const [mfaEnabled, setMfaEnabled] = useState<boolean | null>(null);
  const [v4Username, setV4Username] = useState<string>('');
  const [profileDetails, setProfileDetails] = useState<{
    firstName: string | null;
    lastName: string | null;
    email: string | null;
  }>({
    firstName: null,
    lastName: null,
    email: null,
  });

  const updateProfileDetails = (
    firstName: string | null,
    lastName: string | null,
    email: string | null
  ) => {
    setProfileDetails({ firstName, lastName, email });
  };

  return (
    <DashboardContext.Provider
      value={{
        balances,
        setBalances,
        supportedCurrencies,
        setSupportedCurrencies,
        supportedBalanceCurrencies,
        setSupportedBalanceCurrencies,
        accountName,
        setAccountName,
        v4Username,
        setV4Username,
        user,
        setUser,
        businessName,
        setBusinessName,
        customer,
        setCustomer,
        mfaEnabled,
        setMfaEnabled,
        profileDetails,
        setProfileDetails: updateProfileDetails,
        isMobileView,
        setIsMobileView,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
